import Axios from "axios";

export const getGrowthGraphPercentile = async (url) => {
  const res = await Axios({
    method: "get",
    url: url,
  });

  if (res.status === 200) {
    let array = res?.data?.split("\r\n");
    let result = [];
    let headers = array[0].split(",");

    array.forEach((ele, index) => {
      if (ele.trim() && index !== 0) {
        let str = ele.split(",");
        if (str.length !== 0) {
          let obj = {};
          headers.forEach((head, ind) => {
            obj[ind === 0 ? "value" : head] = Number(str[ind]);
          });
          result.push(obj);
        }
      }
    });
    return result;
  }
};

export const getGrowthGraphZscore = async (url) => {
  const res = await Axios({
    method: "get",
    url: url,
  });

  if (res.status === 200) {
    let array = res?.data?.split("\r\n");
    let result = [];
    let headers = array[0].split(",");

    array.forEach((ele, index) => {
      if (ele.trim() && index !== 0) {
        let str = ele.split(",");
        if (str.length !== 0) {
          let obj = {};
          headers.forEach((head, ind) => {
            obj[ind === 0 ? "value" : "zscore"] = Number(str[ind]);
          });
          result.push(obj);
        }
      }
    });
    return result;
  }
};
